<template lang="pug">
  div
    div.fill-height.full-width.projector
      video.video.v-image__image.v-image__image--contain(
        v-if="media.is_video",
        :controls="showControl || showVideoControls",
        :style="{ 'z-index': showVideoControls ? '1 !important' : 0 }",
      )
        source(:src='media.s3_location', type='video/mp4')
        source(:src='media.s3_location', type='video/ogg')
        | Your browser does not support the video tag.

      v-img.fill-height.full-width(
        v-else,
        contain,
        :src="media.s3_location",
        :aspect-ratio="ratio",
        :position="position",
      )
      div.media-chips(:class="{ 'mb-15': media.is_video && (showControl || showVideoControls) }")
        v-chip.mr-2.mb-1(
          small,
          color="primary",
          v-if="showControl",
        ) {{ media.name }}
        v-chip.mb-1(
          small,
          color="primary",
          @click="$emit('queryDate', formatDate(media.date))",
        ) {{ formatDate(media.date) }}

        v-chip.ml-2.mb-1(
          small,
          color="primary",
          v-for="tag in filteredTags",
          :key="tag.id",
          @click="$emit('queryTag', tag.id)",
        ) {{ stripInitialNumbers(tag.name) }}

        //- filter global media by username 
        //- v-chip.ml-2.mb-1(
        //-   small,
        //-   color="primary",
        //-   v-if="showAdditionalInfo",
        //-   @click="$emit('querySearch', media.user)",
        //- ) {{ media.user }}

        //- v-chip.ml-2.mb-1(
        //-   small,
        //-   color="primary",
        //-   v-if="showAdditionalInfo",
        //-   @click="$emit('querySearch', media.creator)",
        //- ) {{ media.creator }}
    div.mask(
      v-if="showMask",
      @click="$emit('preview'); toggleVideoControl();",
      :class="{ active: active }",
    )
      v-icon(
        dark
      ) {{ media.is_video ? 'fas fa-video' : 'far fa-image' }}
      .subtitle-1.white--text {{ media.name }}
    div.video_mask(
      v-if="showVideoControls",
      @click="showVideoControls = false",
    )
      v-icon(
        dark
      ) fas fa-undo-alt

</template>

<script>
import { mapGetters } from "vuex";
import { formatDate, stripInitialNumbers } from "@/utils/helper";

export default {
  props: {
    allowVideoToggle: {
      type: Boolean,
      default: false,
    },

    showMask: {
      type: Boolean,
      default: false,
    },

    active: {
      type: Boolean,
      default: false,
    },

    media: {
      type: Object,
      required: true,
    },

    ratio: {
      type: String,
      default: "1",
    },

    position: {
      type: String,
      default: "center center",
    },

    showControl: {
      type: Boolean,
      default: false,
    },

    showAdditionalInfo: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    showVideoControls: false,
  }),

  computed: {
    ...mapGetters({
      mediaTags: "mediaTag/items",
    }),

    filteredTags() {
      return this.media.media_list.map((media_id) => {
        const media = this.mediaTags.find(({ id }) => id === media_id);

        return media;
      });
    },
  },

  methods: {
    formatDate,
    stripInitialNumbers,
    toggleVideoControl() {
      if (this.media.is_video && this.allowVideoToggle) {
        this.showVideoControls = !this.showVideoControls;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.projector {
  max-height: 396px;
  max-width: 528px;
  margin: auto;
}
</style>
